import { useState } from "react";
import "../App.css";
import { Link, NavLink } from "react-router-dom";

const Navbar = () => {
  const [activeLabel, setActiveLabel] = useState("Home");
  const [menu__section, setmenu__section] = useState(false);
  const token = localStorage.getItem('userToken')

  const menu_items = [
    {
      Label: "Home",
      icon: <i className="ri-home-fill"></i>,
      to: "/",
    },
    {
      Label: "Suitable Career Option",
      icon: <i className="ri-book-open-line"></i>,
      to: "Carrer",
    },
    {
      Label: "Resume",
      icon: <i className="ri-information-line"></i>,
      to: "/dashboard/resume",
    },
    {
      Label: "Exam Alerts",
      icon: <i className="ri-book-open-line"></i>,
      to: "/dashboard/exam-alerts",
    },
  ];

  return (
    <div>
      {/* ✅ Desktop Navbar */}
      <div className="lg:block hidden">
        <section
          style={{ position: "fixed", top: "0", left: "0", width: "100%", zIndex: "30000" }}
          className="bg-white shadow-md"
        >
          <div className="max-w-[1300px] mx-auto px-6 md:px-[90px] h-[90px] flex items-center justify-between">
            <div className="flex items-center h-[90px]">
              <Link to="/">
                <img src="/assates/Logo__newimage.png" className="w-[100px] h-[90px]" />
              </Link>
            </div>

            <div className="hidden md:flex items-center gap-[40px] h-[90px]">
              <ul className="flex gap-[10px]">
                {menu_items.map((item, index) => (
                  <li key={index} className="cursor-pointer">
                    <NavLink
                      to={item.to !== "Carrer" ? item.to : "#"}
                      onClick={(e) => {
                        setActiveLabel(item.Label);
                        if (item.to === "Carrer") {
                          e.preventDefault();
                          const element = document.getElementById("career-section");
                          if (element) element.scrollIntoView({ behavior: "smooth" });
                        }
                      }}
                      className={`px-4 py-2 text-[15px] font-[700] flex items-center gap-2 ${activeLabel === item.Label
                        ? "text-black rounded"
                        : "text-gray-400 hover:rounded-md hover:text-[#28282B]"
                        }`}
                    >
                      {item.icon}
                      {item.Label}
                    </NavLink>
                  </li>
                ))}
              </ul>
            </div>

            {
              token ? <div className="flex items-center h-[90px]">
                <Link to="/Dashboard" onClick={() => setmenu__section(false)}>
                  <button className="w-[200px] h-[48px] rounded-[10px] text-[18px] font-[600] bg-[#28282B] text-white">
                    <i className="ri-login-circle-line mr-2"></i>
                    Dashboard
                  </button>
                </Link>
              </div> :
                <div className="flex items-center h-[90px]">
                  <Link to="/Login" onClick={() => setmenu__section(false)}>
                    <button className="w-[118px] h-[48px] rounded-[15px] text-[18px] font-[600] bg-[#28282B] text-white">
                      <i className="ri-login-circle-line"></i>
                      Login
                    </button>
                  </Link>
                </div>
            }
          </div>
        </section>
      </div>

      {/* ✅ Mobile Navbar */}
      <div className="mobile_navber">
        <div className="lg:hidden block">
          <section
            style={{ position: "fixed", top: "0", left: "0", width: "100%", zIndex: "30000" }}
            className="bg-white shadow-md"
          >
            <div className="flex justify-between px-2 items-center">
              <div>
                <img src="/assates/Logo____new.jpg" className="w-[100px] h-[80px]" />
              </div>
              <div onClick={() => setmenu__section(!menu__section)}>
                <i className="ri-menu-3-line text-3xl"></i>
              </div>
            </div>

            {menu__section && (
              <div className="absolute top-20 left-0 h-[100vh] bg-white w-full">
                <div className="px-2 py-4">
                  <ul className="flex gap-[10px] flex-col">
                    {menu_items.map((item, index) => (
                      <li key={index} className="cursor-pointer">
                        <NavLink
                          to={item.to !== "Carrer" ? item.to : "#"}
                          onClick={(e) => {
                            setActiveLabel(item.Label);
                            if (item.to === "Carrer") {
                              e.preventDefault();
                              const element = document.getElementById("career-section");
                              if (element) element.scrollIntoView({ behavior: "smooth" });
                            }
                            // ✅ Close menu after click (always)
                            setmenu__section(false);
                          }}
                          className={`px-4 py-2 text-[15px] font-[700] flex items-center gap-2 ${activeLabel === item.Label
                            ? "text-black rounded"
                            : "text-gray-400 hover:rounded-md hover:text-[#28282B]"
                            }`}
                        >
                          {item.icon}
                          {item.Label}
                        </NavLink>
                      </li>
                    ))}
                  </ul>
                  {
                    token ? <div className="flex items-center h-[90px]">
                      <Link to="/Dashboard" onClick={() => setmenu__section(false)}>
                        <button className="w-[200px] h-[48px] rounded-[10px] text-[18px] font-[600] bg-[#28282B] text-white">
                          <i className="ri-login-circle-line mr-2"></i>
                          Dashboard
                        </button>
                      </Link>
                    </div> :
                      <div className="flex items-center h-[90px]">
                        <Link to="/Login" onClick={() => setmenu__section(false)}>
                          <button className="w-[118px] h-[48px] rounded-[15px] text-[18px] font-[600] bg-[#28282B] text-white">
                            <i className="ri-login-circle-line"></i>
                            Login
                          </button>
                        </Link>
                      </div>
                  }

                </div>
              </div>
            )}
          </section>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
